module.exports = __webpack_public_path__ + "media/images/front/about/e-mediceo/cc_renewal_sp_001-5093a07ee6567896a76ecf1cc14275be.png";